import { useEffect, useState } from 'react';
import { toast } from './toast';

interface ToastItem {
  id: number;
  type: 'success' | 'error' | 'warn';
  message: string;
}

let _id = 0;

export default function ToastContainer() {
  const [items, setItems] = useState<ToastItem[]>([]);

  useEffect(() => {
    toast._subscribe((type, message) => {
      const id = ++_id;
      setItems(prev => [...prev, { id, type, message }]);
      setTimeout(() => setItems(prev => prev.filter(t => t.id !== id)), 3500);
    });
    return () => toast._unsubscribe();
  }, []);

  if (!items.length) return null;

  return (
    <div className="fixed bottom-4 right-4 z-[9999] flex flex-col gap-2 pointer-events-none">
      {items.map(t => (
        <div
          key={t.id}
          className={`flex items-center gap-2 px-4 py-3 rounded-lg shadow-lg text-sm font-semibold text-white pointer-events-auto min-w-[240px] max-w-sm animate-fade-in ${
            t.type === 'success' ? 'bg-green-600' : t.type === 'warn' ? 'bg-amber-500' : 'bg-red-600'
          }`}
        >
          <i className={`text-lg flex-shrink-0 ${t.type === 'success' ? 'ri-checkbox-circle-line' : t.type === 'warn' ? 'ri-alert-line' : 'ri-error-warning-line'}`}></i>
          <span>{t.message}</span>
        </div>
      ))}
    </div>
  );
}
